export default {
  //API_ENDPOINT: 'http://localhost:8000/',
  API_ENDPOINT: 'https://powerful-retreat-93899.herokuapp.com/',
  TOKEN_KEY: 'cattyshack-client-auth-token',
  API_KEY: ''
};
